export default "__VITE_ASSET__Dnb$NPM2__"